import { LeftOutlined } from "@ant-design/icons";
import { ICampaignForm } from "@utils/Interfaces";
import { Button, Input, Select, Slider, Row, Col, DatePicker } from "antd";
import dayjs from "dayjs";
import './CampaignForm.scss'

const CampaignForm: React.FC<ICampaignForm> = ({
  campaignList,
  campaignForm,
  handleChangeCampaignForm,
  setIsCreateNew,
  setIsOpenCreateForm,
  positionListOptions,
  levelListOptions,
  startDateAllPhase,
  endDateAllPhase,
}) => {
  return (
    <div className="CampaignForm">
      <div className="form-title">
        <Button
          color="default"
          variant="link"
          icon={<LeftOutlined />}
          onClick={() => {
            if (campaignList.length == 0) setIsOpenCreateForm(false);
            setIsCreateNew(false);
          }}
        ></Button>
        <div className="form-h2">Create New Campaign</div>
      </div>
      <div className="form-group">
        <div className="form-label">
          Campaign Name<span className="text-danger">*</span>
        </div>
        <Input
          size="large"
          onChange={(e) =>
            handleChangeCampaignForm(e.target.value, "campaign_name")
          }
          value={campaignForm.campaign_name}
          variant="filled"
          className="campaign-name"
        />
      </div>
      <div className="form-group">
        <div className="form-label">
          Position<span className="text-danger">*</span>
        </div>
        <Select
          className="w-100 campaign-position"
          showSearch
          variant="filled"
          onChange={(value: any, option: any) =>
            handleChangeCampaignForm(option.label, "position")
          }
          size="large"
          filterOption={(input, option) =>
            (typeof option?.label === "string" ? option.label : "")
              .toLowerCase()
              .includes(input.toLowerCase())
          }
          options={positionListOptions()}
        />
      </div>
      <div className="form-group">
        <div className="form-label">
          Experience Level
          <span className="text-danger">*</span>
        </div>
        <Select
          className="w-100 campaign-experience"
          showSearch
          onChange={(value: any, option: any) =>
            handleChangeCampaignForm(option.label, "experience_level")
          }
          variant="filled"
          size="large"
          filterOption={(input, option) =>
            (typeof option?.label === "string" ? option.label : "")
              .toLowerCase()
              .includes(input.toLowerCase())
          }
          options={levelListOptions()}
        />
      </div>
      <div className="form-group campaign-budget">
        <div className="form-label">
          <div className="label">
            Budget<span className="text-danger">*</span>
          </div>
          <div className="currency-unit-setting">
            Max.
            <Input size="small" variant="filled" value={"500,000"} />
            <Select
              size="small"
              defaultValue="vnd"
              onChange={() => console.log(1)}
              options={[
                { value: "vnd", label: "VNĐ" },
                { value: "usd", label: "USD" },
              ]}
            />
          </div>
        </div>
        <div className="heppcoin-exchange">(~300 HeppCoin)</div>
        <Slider
          className="budget-slider"
          min={0}
          max={5000}
          value={campaignForm.budget}
          onChange={(value) => handleChangeCampaignForm(value, "budget")}
        />
      </div>
      <Row gutter={16} className="campaign-date">
        <Col span={12}>
          <div className="form-group">
            <div className="form-label">
              Start Date<span className="text-danger">*</span>
            </div>
            <DatePicker
              variant={"filled"}
              onChange={(date, dateString) =>
                handleChangeCampaignForm(dateString, "start_date")
              }
              value={dayjs(startDateAllPhase)}
            />
          </div>
        </Col>
        <Col span={12}>
          <div className="form-group">
            <div className="form-label">
              End Date<span className="text-danger">*</span>
            </div>
            <DatePicker
              variant={"filled"}
              onChange={(date, dateString) =>
                handleChangeCampaignForm(dateString, "end_date")
              }
              value={dayjs(endDateAllPhase)}
            />
          </div>
        </Col>
      </Row>
      <div className="form-group">
        <div className="form-label">
          Duration<span className="text-danger">*</span>
        </div>
        <Input
          type="number"
          className="campaign-duration"
          size="large"
          onChange={(e) => handleChangeCampaignForm(e.target.value, "duration")}
          value={campaignForm.duration}
          variant="filled"
        />
      </div>
    </div>
  );
};

export default CampaignForm;
